import React, {useState} from "react";
import {observer} from "mobx-react";
import {Checkbox, Dialog, DialogContent, DialogTitle, IconButton, TextField} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import SearchIcon from "@mui/icons-material/Search";
import ListItemText from "@mui/material/ListItemText";
import CloseIcon from "@mui/icons-material/Close";
import {useForceUpdate, useStores} from "../../Hooks";
import {procedureTypeEnum} from "../../serverClientShared/sharedEnums";

const ProceduresListDialogSingleProject = observer(({
                                                        handleSelectProcedure,
                                                        open,
                                                        closeModal,
                                                        rootProcedureId,
                                                        selectedProceduresMap,
                                                        isSelectSingleProcedure,
                                                        selectedSingleProcedureId
                                                    }) => {
    const {generalStore, projectStore, dataStore} = useStores();

    const [proceduresSearchVal, setProceduresSearchVal] = useState('');
    const [filteredProceduresMap, setFilteredProceduresMap] = useState(new Map());
    const [allProceduresMap, setAllProceduresMap] = useState(new Map());
    const forceUpdate = useForceUpdate();

    async function searchProcedures(event) {
        const search = event.target.value;
        setProceduresSearchVal(search);
        filterProcedures(search);
    }

    function filterProcedures(search) {
        const updatedFilteredProceduresMap = new Map();

        allProceduresMap.forEach((procedure, procedureId) => {
            const searchFound = procedure.ProcedureName.toLowerCase().includes(search.toLowerCase());
            if (searchFound) {
                updatedFilteredProceduresMap.set(procedureId, procedure);
            }
        });
        setFilteredProceduresMap(updatedFilteredProceduresMap);
    }

    function renderFilteredProceduresList() {
        const listItems = [];
        filteredProceduresMap.forEach((procedure, procedureId) => {
            if (procedureId === rootProcedureId || !procedure.IsPublished) {
                return
            }
            const isSelected = isSelectSingleProcedure ? selectedSingleProcedureId === procedureId : selectedProceduresMap.has(procedureId);
            const procedureListItem = (
                <ListItem
                    key={procedureId}
                    button
                    onClick={() => {
                        handleSelectProcedure(procedure);
                        forceUpdate();
                        closeModal();
                    }}
                >
                    <Checkbox
                        checked={isSelected}
                        color='primary'
                        inputProps={{'aria-labelledby': procedureId}}
                        disableRipple
                    />
                    <ListItemText primary={procedure.ProcedureName} id={procedureId}
                                  style={{overflowWrap: "anywhere"}}/>
                </ListItem>
            );
            listItems.push(procedureListItem)
        });
        return <List>{listItems}</List>
    }


    async function onOpenProceduresDialog() {
        generalStore.isLoaderOpen = true;
        const projectsMap = dataStore.projectsProceduresMap;
        const projectProceduresMap = projectsMap.get(projectStore.currentProject?.ProjectIdentifier) || new Map();    //get procedures
        const regularProceduresMap = new Map();
        projectProceduresMap.forEach(procedure => {
            if (procedure.ProcedureType !== procedureTypeEnum.REGULAR) {
                return;
            }
            regularProceduresMap.set(procedure.ProcedureIdentifier, procedure);
        });
        setFilteredProceduresMap(regularProceduresMap);
        setAllProceduresMap(regularProceduresMap);
        setProceduresSearchVal("")
        generalStore.isLoaderOpen = false;
    }

    return (
        <Dialog
            className='search-procedures-dialog'
            open={open}
            onClose={closeModal}
            TransitionProps={{
                onEnter: onOpenProceduresDialog
            }}
            maxWidth='sm'
            fullWidth
        >
            <IconButton className='close-button' onClick={closeModal}>
                <CloseIcon/>
            </IconButton>
            <DialogTitle>
                <div className='search-procedures-container'>
                    <TextField
                        className='search-procedures'
                        placeholder={generalStore.translate('procedureName_withEllipsis')}
                        value={proceduresSearchVal}
                        onChange={searchProcedures}
                        fullWidth
                        variant='outlined'
                    />
                    <SearchIcon/>
                </div>
            </DialogTitle>
            <DialogContent>
                {filteredProceduresMap.size ? renderFilteredProceduresList() : generalStore.translate('noResults')}
            </DialogContent>
        </Dialog>
    );
});
export default ProceduresListDialogSingleProject;
